export default [
  {
    id: "1",

    alpha3Code: "NGA",

    name: "Abia",
  },

  {
    id: "2",

    alpha3Code: "NGA",

    name: "Adamawa",
  },

  {
    id: "3",

    alpha3Code: "NGA",

    name: "Akwa Ibom",
  },

  {
    id: "4",

    alpha3Code: "NGA",

    name: "Anambra",
  },

  {
    id: "5",

    alpha3Code: "NGA",

    name: "Bauchi",
  },

  {
    id: "6",

    alpha3Code: "NGA",

    name: "Bayelsa",
  },

  {
    id: "7",

    alpha3Code: "NGA",

    name: "Benue",
  },

  {
    id: "8",

    alpha3Code: "NGA",

    name: "Borno",
  },

  {
    id: "9",

    alpha3Code: "NGA",

    name: "Cross River",
  },

  {
    id: "10",

    alpha3Code: "NGA",

    name: "Delta",
  },

  {
    id: "11",

    alpha3Code: "NGA",

    name: "Ebonyi",
  },

  {
    id: "12",

    alpha3Code: "NGA",

    name: "Edo",
  },

  {
    id: "13",

    alpha3Code: "NGA",

    name: "Ekiti",
  },

  {
    id: "14",

    alpha3Code: "NGA",

    name: "Enugu",
  },

  {
    id: "15",

    alpha3Code: "NGA",

    name: "FCT",
  },

  {
    id: "16",

    alpha3Code: "NGA",

    name: "Gombe",
  },

  {
    id: "17",

    alpha3Code: "NGA",

    name: "Imo",
  },

  {
    id: "18",

    alpha3Code: "NGA",

    name: "Jigawa",
  },

  {
    id: "19",

    alpha3Code: "NGA",

    name: "Kaduna",
  },

  {
    id: "20",

    alpha3Code: "NGA",

    name: "Kano",
  },

  {
    id: "21",

    alpha3Code: "NGA",

    name: "Katsina",
  },

  {
    id: "22",

    alpha3Code: "NGA",

    name: "Kebbi",
  },

  {
    id: "23",

    alpha3Code: "NGA",

    name: "Kogi",
  },

  {
    id: "24",

    alpha3Code: "NGA",

    name: "Kwara",
  },

  {
    id: "25",

    alpha3Code: "NGA",

    name: "Lagos",
  },

  {
    id: "26",

    alpha3Code: "NGA",

    name: "Nasarawa",
  },

  {
    id: "27",

    alpha3Code: "NGA",

    name: "Niger",
  },

  {
    id: "28",

    alpha3Code: "NGA",

    name: "Ogun",
  },

  {
    id: "29",

    alpha3Code: "NGA",

    name: "Ondo",
  },

  {
    id: "30",

    alpha3Code: "NGA",

    name: "Osun",
  },

  {
    id: "31",

    alpha3Code: "NGA",

    name: "Oyo",
  },

  {
    id: "32",

    alpha3Code: "NGA",

    name: "Plateau",
  },

  {
    id: "33",

    alpha3Code: "NGA",

    name: "Rivers",
  },

  {
    id: "34",

    alpha3Code: "NGA",

    name: "Sokoto",
  },

  {
    id: "35",

    alpha3Code: "NGA",

    name: "Taraba",
  },

  {
    id: "36",

    alpha3Code: "NGA",

    name: "Yobe",
  },

  {
    id: "37",

    alpha3Code: "NGA",

    name: "Zamfara",
  },
];
